import moment from 'moment';

export class RsjPaymentDataDto {
  public id: number;
  public beginDate: Date;
  public endDate: Date;
  public beneficiaryId: number;
  public holderFirstName: string;
  public holderLastName: string;
  public bankName: string;
  public iban: string;
  public bic: string;
  public livretA: boolean;
  public pdfId: number;
  public pdfName: string;
  public pdfData: string;
  public historizedPaymentData: RsjPaymentDataDto[];
  public hasPayments: boolean;
  public visa: boolean;

  public static fromJson(json: any): RsjPaymentDataDto {
    if (json) {
      return {
        id: json.id,
        beginDate: json.beginDate ? moment.utc(json.beginDate).toDate() : undefined,
        endDate: json.endDate ? moment.utc(json.endDate).toDate() : undefined,
        beneficiaryId: json.beneficiaryId,
        holderFirstName: json.holderFirstName,
        holderLastName: json.holderLastName,
        bankName: json.bankName,
        iban: json.iban,
        bic: json.bic,
        livretA: json.livretA,
        pdfId: json.pdfId,
        pdfName: json.pdfName,
        historizedPaymentData: (json.historizedPaymentData || []).map(RsjPaymentDataDto.fromJson),
        hasPayments: json.hasPayments,
        visa: json.visa,
      } as RsjPaymentDataDto;
    }
  }
}
